import { Component, effect, input, signal } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NgClass } from '@angular/common';
import { svgIconKeys } from '../../../constants/svg-icon-keys';
import { daysUntilNextVisitToColorKey } from '../../utils/days-until-next-visit-to-color-key';
import { daysBetweenDates } from '../../utils/days-between-dates';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'blindspot-ideal-visit-day-pill',
  styleUrls: ['./ideal-visit-day-pill.component.scss'],
  imports: [SvgIconComponent, NgClass, TranslocoModule],
  template: `
    <div class="icon-pill" [ngClass]="pillColor" *transloco="let t">
      <svg-icon
        class="svg"
        svgClass="icon"
        [src]="svgIconKeys.target"
      ></svg-icon>
      <span
        >{{ daysUntilNextVisit() }}
        {{
          daysUntilNextVisit() === 1 || daysUntilNextVisit() === -1
            ? t('days.day')
            : t('days.days')
        }}
      </span>
    </div>
  `,
})
export class IdealVisitDayPill {
  public idealNextVisitDate = input.required<Date>();

  public visitDate = input.required<Date>();

  public daysUntilNextVisit = signal(0);

  public pillColor: 'green' | 'yellow' | 'red' | 'blue' = 'blue';

  constructor() {
    effect(() => {
      // Get the difference in days between ideal next visit date and the visit date
      this.daysUntilNextVisit.set(
        daysBetweenDates(new Date(this.idealNextVisitDate()), this.visitDate()),
      );

      // Set the pill color based on the number of days until the next visit
      this.pillColor = daysUntilNextVisitToColorKey(this.daysUntilNextVisit());
    });
  }

  protected readonly svgIconKeys = svgIconKeys;
}
